/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M16 3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3C8 1.89543 8.89543 1 10 1H14C15.1046 1 16 1.89543 16 3ZM16 3C18.2091 3 20 4.79086 20 7V14C20 14.5516 20 15.0489 19.9958 15.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 2L4.71586 4.71586M22 22L19.3912 19.3912M4.71586 4.71586C4.26461 5.36347 4 6.15083 4 7V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22C14.8003 22 16.2004 22 17.27 21.455C18.17 20.9964 18.9091 20.2765 19.3912 19.3912M4.71586 4.71586L19.3912 19.3912"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M4 6.99996V14C4 16.8002 4 18.2003 4.54497 19.2699C5.02433 20.2107 5.78924 20.9756 6.73005 21.455C7.79961 22 9.19974 22 12 22C14.8003 22 16.2004 22 17.27 21.455C18.17 20.9964 18.9091 20.2764 19.3912 19.3911L4.71586 4.71582C4.26461 5.36343 4 6.15079 4 6.99996Z"
				fill="currentColor"
			/>
			<path
				d="M16 3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3C8 1.89543 8.89543 1 10 1H14C15.1046 1 16 1.89543 16 3ZM16 3C18.2091 3 20 4.79086 20 7V14C20 14.5516 20 15.0489 19.9958 15.5M2 2L4.71586 4.71586M22 22L19.3912 19.3912M4.71586 4.71586C4.26461 5.36347 4 6.15083 4 7V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22C14.8003 22 16.2004 22 17.27 21.455C18.17 20.9964 18.9091 20.2765 19.3912 19.3912M4.71586 4.71586L19.3912 19.3912"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11 0.25C9.74121 0.25 8.67996 1.09576 8.35351 2.25003C7.9665 2.25037 7.70229 2.25349 7.46817 2.27987C7.24485 2.30503 7.02605 2.34557 6.81292 2.40047C6.4118 2.50379 6.17039 2.91272 6.27371 3.31384C6.37703 3.71496 6.78596 3.95638 7.18708 3.85305C7.33277 3.81553 7.48267 3.78772 7.63612 3.77044C7.78235 3.75396 7.95976 3.75072 8.35355 3.75012C8.68006 4.90431 9.74127 5.75 11 5.75H13C14.2587 5.75 15.3199 4.90431 15.6464 3.75012C16.0402 3.75072 16.2177 3.75396 16.3639 3.77044C17.8706 3.94021 19.0598 5.12935 19.2296 6.63612C19.2488 6.80693 19.25 7.02031 19.25 7.57143V13C19.25 13.2609 19.251 13.5101 19.2521 13.7493V13.7494C19.2539 14.1976 19.2557 14.6104 19.2501 14.9978C19.2441 15.412 19.575 15.7526 19.9892 15.7586C20.4033 15.7646 20.7439 15.4337 20.7499 15.0195C20.7557 14.6188 20.7539 14.1814 20.752 13.723L20.752 13.7219C20.751 13.4861 20.75 13.2448 20.75 13V7.57143L20.75 7.51702V7.51697C20.75 7.0383 20.7501 6.73386 20.7201 6.46817C20.472 4.26597 18.734 2.52799 16.5318 2.27987C16.2977 2.25349 16.0335 2.25037 15.6465 2.25003C15.32 1.09576 14.2588 0.25 13 0.25H11ZM9.75 3C9.75 2.30964 10.3096 1.75 11 1.75H13C13.6904 1.75 14.25 2.30964 14.25 3C14.25 3.69036 13.6904 4.25 13 4.25H11C10.3096 4.25 9.75 3.69036 9.75 3ZM2.53033 1.46967C2.23744 1.17678 1.76256 1.17678 1.46967 1.46967C1.17678 1.76256 1.17678 2.23744 1.46967 2.53033L3.77256 4.83322C3.51625 5.33301 3.34563 5.88454 3.27987 6.46817C3.24993 6.73386 3.24996 7.03831 3.25 7.517V7.51701L3.25 7.57143V13L3.25 13.0564C3.24998 14.8942 3.24997 16.3498 3.40313 17.489C3.56076 18.6614 3.89288 19.6104 4.64124 20.3588C5.38961 21.1071 6.33855 21.4392 7.51098 21.5969C8.65018 21.75 10.1058 21.75 11.9435 21.75H11.9436H12H12.0564H12.0565C13.8942 21.75 15.3498 21.75 16.489 21.5969C17.6456 21.4414 18.5847 21.1161 19.3283 20.3889L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L19.799 18.7383L5.24632 4.18566L2.53033 1.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3C8 1.89543 8.89543 1 10 1H14C15.1046 1 16 1.89543 16 3ZM16 3C18.2091 3 20 4.79086 20 7V14C20 14.5516 20 15.0489 19.9958 15.5M2 2L4.71586 4.71586M22 22L19.3912 19.3912M4.71586 4.71586C4.26461 5.36347 4 6.15083 4 7V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22C14.8003 22 16.2004 22 17.27 21.455C18.17 20.9964 18.9091 20.2765 19.3912 19.3912M4.71586 4.71586L19.3912 19.3912"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16 3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3C8 1.89543 8.89543 1 10 1H14C15.1046 1 16 1.89543 16 3ZM16 3C18.2091 3 20 4.79086 20 7V14C20 14.5516 20 15.0489 19.9958 15.5M2 2L4.71586 4.71586M22 22L19.3912 19.3912M4.71586 4.71586C4.26461 5.36347 4 6.15083 4 7V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22C14.8003 22 16.2004 22 17.27 21.455C18.17 20.9964 18.9091 20.2765 19.3912 19.3912M4.71586 4.71586L19.3912 19.3912"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.2498 2.25C8.44949 2.25 7.04936 2.25 5.9798 2.79497C5.03899 3.27433 4.27409 4.03924 3.79472 4.98005C3.24976 6.04961 3.24976 7.44974 3.24976 10.25V14C3.24976 16.5612 3.24976 17.8417 3.63432 18.8635C4.24295 20.4806 5.51917 21.7568 7.13626 22.3654C8.15802 22.75 9.4386 22.75 11.9998 22.75C14.5609 22.75 15.8415 22.75 16.8633 22.3654C18.4803 21.7568 19.7566 20.4806 20.3652 18.8635C20.7498 17.8417 20.7498 16.5612 20.7498 14V10.25C20.7498 7.44974 20.7498 6.04961 20.2048 4.98005C19.7254 4.03924 18.9605 3.27433 18.0197 2.79497C16.9501 2.25 15.55 2.25 12.7498 2.25H11.2498Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 0.25C8.89543 0.25 8 1.14543 8 2.25C8 3.35457 8.89543 4.25 10 4.25H14C15.1046 4.25 16 3.35457 16 2.25C16 1.14543 15.1046 0.25 14 0.25H10ZM1.46967 1.46967C1.76256 1.17678 2.23744 1.17678 2.53033 1.46967L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L19.5083 20.569C18.9976 21.2141 18.3515 21.7457 17.6104 22.1233C16.9523 22.4586 16.2252 22.6075 15.3451 22.6794C14.4807 22.75 13.4053 22.75 12.0337 22.75H12.0336H12.0336H11.9664H11.9664H11.9663C10.5947 22.75 9.51926 22.75 8.65494 22.6794C7.77479 22.6075 7.04768 22.4586 6.38955 22.1233C5.30762 21.572 4.42798 20.6924 3.87671 19.6104C3.54138 18.9523 3.39252 18.2252 3.32061 17.3451C3.24999 16.4807 3.25 15.4053 3.25 14.0336V7C3.25 6.22017 3.43843 5.48301 3.77223 4.83289L1.46967 2.53033C1.17678 2.23744 1.17678 1.76256 1.46967 1.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
